import { isBefore, isToday, startOfYesterday } from 'date-fns'
import { FC, useCallback, useState } from 'react'
import { ActionModalLayout, DatePicker, Modal, RoundedButton } from '../../shared'
import { TerminateTreatmentModalProps } from './TerminateTreatmentModal.model'
import styles from './TerminateTreatmentModal.module.scss'

export const TerminateTreatmentModal: FC<TerminateTreatmentModalProps> = ({
  treatment,
  isUnmounting,
  onClose,
  onValid,
}) => {
  const [endDate, setEndDate] = useState<Date | null>(startOfYesterday())

  const handleClose = useCallback(() => {
    setEndDate(startOfYesterday())
    onClose()
  }, [onClose])

  const handleValid = useCallback(() => {
    if (endDate !== null) {
      onValid(endDate)
    }
    handleClose()
  }, [endDate, handleClose, onValid])

  // Cas exceptionnel : Si le traitement commence aujourd'hui, je peux mettre une date de fin à hier
  const isEndDateValid =
    endDate !== null &&
    treatment?.startDate &&
    (isToday(treatment.startDate)
      ? !isBefore(endDate, startOfYesterday())
      : !isBefore(endDate, treatment.startDate))

  return (
    <Modal isUnmounting={isUnmounting} onClickOutside={handleClose}>
      <ActionModalLayout
        key={treatment?.id}
        title="Arrêt de traitement"
        onClose={onClose}
        actions={
          <div className={styles.terminateTreatmentModalActions}>
            <RoundedButton
              label="Annuler"
              onClick={handleClose}
              theme="transparent-dark"
              testId="button-treatment-cancel"
            />
            <RoundedButton
              label="Valider"
              disabled={!isEndDateValid}
              onClick={handleValid}
              theme="primary"
              testId="button-treatment-validate"
            />
          </div>
        }
      >
        <div className={styles.terminateTreatmentModalDatePickerContainer}>
          <div className={styles.terminateTreatmentModalDatePicker}>
            <DatePicker
              label="Date de dernière prise du traitement"
              clearable={false}
              colorPreset="light"
              value={endDate}
              onChange={(date) => {
                setEndDate(date)
              }}
              inputType="input"
              testId="date_picker-drug-treatment-end"
            />
          </div>
        </div>
      </ActionModalLayout>
    </Modal>
  )
}
